import {CHANGE_TOPICS} from 'src/pages/category/store/actions/topics';
import {hashify} from 'src/pages/category/utils';

export const selectedTopics = (state = '', action) => {
  switch (action.type) {
    case CHANGE_TOPICS: {
      const {topic, subtopic} = action.value;
      if (!topic) {
        return '';
      }
      if (!subtopic) {
        // If there is only a single subtopic for a topic then select that by default when changing topics
        // Unless that topic was already selected, in which case the user is collapsing the subtopic
        if (topic.subtopics.length === 1) {
          const selected = `${hashify(topic.name)}/${hashify(topic.subtopics[0].name)}`;
          if (selected !== state) {
            return selected;
          }
        }
        return hashify(topic.name);
      }
      return `${hashify(topic.name)}/${hashify(subtopic.name)}`;
    }
    default:
      return state;
  }
};
